import { FormErrors } from "@/components/forms/form-errors";
import { usePage } from "@inertiajs/react";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export function Errors({ targets = {} }: { targets?: Record<string, string> }) {
  const { errors } = usePage().props;
  return <FormErrors errors={errors || {}} targets={targets} />;
}

export function Choice({
  id,
  name,
  label,
  options,
  defaultValue,
  value,
  onValueChange,
}: {
  id: string;
  name: string;
  label: string;
  options: { id: string; name: string }[];
  defaultValue?: string;
  value?: string;
  onValueChange?: (value: string | null) => void;
}) {
  return (
    <div className="flex min-w-0 flex-col gap-2">
      <Label htmlFor={id}>{label}</Label>
      <Select
        name={name}
        defaultValue={defaultValue}
        value={value}
        required
        items={Object.fromEntries(
          options.map((option) => [option.id, option.name]),
        )}
        onValueChange={onValueChange}
      >
        <SelectTrigger id={id} className="w-full">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.id} value={option.id}>
              {option.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
